jQuery(document).ready(function($) {

  /*
  jQuery throttle / debounce - v1.1 - 3/7/2010 -- Rewritten to accommodate webpack compilation
  http://benalman.com/projects/jquery-throttle-debounce-plugin/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  /*
  $(window).on('scroll', st_throttle(500, function() {
    console.log('do something');
  }));
  */


  /* MODAAL FUNCTIONALITY --------------------------------------- */

  // For text/image columns with a video button
  $('a.modaal-video').modaal({
    type: 'video'
  });

  $('a.modaal-iframe').modaal({
    type: 'iframe'
  });

  $('a.modaal-inline').modaal({
  });

  $('a.tvb-modaal-inline').modaal({
    custom_class: 'tvb-modaal-wrapper'
  });

  $('a.cgg-modaal-inline').modaal({
    custom_class: 'cgg-modaal-wrapper',
    width: 1920
  });


  /* MOBILE MENU TRIGGER ---------------------------------------- */
  $('#mm-trigger').on('click', function() {

    // Set variables
    var $menu_container = $('#campaign-header > .wrap');
    var $menu_wrap = $('#campaign-header .menu-wrap');
    var menu_wrap_height = $menu_wrap.innerHeight();

    // If the menu is open, close it -else- open it
    if ($('body').hasClass('menu-open')) {
      $('body').removeClass('menu-open');
      $menu_container.css({
        'max-height': ''
      });
    } else {
      $('body').addClass('menu-open');
      $menu_container.css({
        'max-height': menu_wrap_height+'px'
      });
    }

  });


  /* GRANTEES GRID ---------------------------------------------- */
  $('.campaign-grantees-grid').each(function() {

    // Create the variables for the necessary items
    var $cgg = $(this);
    var $items = $('.grid-item', $cgg);
    var $expander_wrap = $('.cgg-expander', $cgg);
    var $expander = $('button', $expander_wrap);

    // Handle the click functionality of the expander button
    $expander.on('click', function() {

      // Add the display-all class in order to hide the expander
      $cgg.addClass('display-all');

      // Add the show class to all items
      $items.addClass('show');

    });

    // Reusable function that determines how many items to show and whether or not the expander button should be visible
    function wrap_items() {

      // Only bother with this if the grid is not already displaying all items
      if (!$cgg.hasClass('display-all')) {

        // Remove the show class from all items
        $items.removeClass('show');

        // Set variable of window width
        var window_width = $(window).innerWidth();

        // All conditionals below check that 1) if more items exist than should be shown then we reveal the expander button and 2) we only show the maximum number of items at each breakpoint
        if (window_width > 1200) {
          if ($items.length > 9) {
            $expander_wrap.addClass('show');
          }
          $('.grid-item:lt(9)', $cgg).addClass('show');
        } else if (window_width > 750) {
          if ($items.length > 8) {
            $expander_wrap.addClass('show');
          }
          $('.grid-item:lt(8)', $cgg).addClass('show');
        } else {
          if ($items.length > 4) {
            $expander_wrap.addClass('show');
          }
          $('.grid-item:lt(4)', $cgg).addClass('show');
        }

      }

    }

    // Run the wrap_items() function on page load
    wrap_items();

    // Run the wrap_items() function as the window is resized
    $(window).on('resize', st_throttle(500, function() {
      wrap_items();
    }));

  });
  
  
  /* SMOOTH SCROLLING ------------------------------------------- */
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href*="#modal"]').not('.cgg-modaal-inline').not('.tvb-modaal-inline').click(function(t){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){

    var e = $(this.hash);

    // Determine the heights of possible elements on the page to take into consideration
    var header_height = 0; 
    header_height = $('#campaign-header').innerHeight(); // Fixed headers need to be taken into consideration

    var wpadminbar_height = 0; // ($('#wpadminbar').length > 0 ? $('#wpadminbar').innerHeight() : 0); // Height of WordPress admin bar
    var scroll_top_padding = 20; // Extra padding

    var total_offset = header_height + wpadminbar_height + scroll_top_padding;

    console.log(total_offset);
    // Calculate the final offset for scrolling by removing the height of the items above (and some padding) from the total offset height
    var e_offset_top = e.offset().top - total_offset;

  (e=e.length?e:$("[name="+this.hash.slice(1)+"]")).length&&(t.preventDefault(),$("html, body").animate({
    scrollTop:e_offset_top
  },1e3,function(){var t=$(e);if(t.focus(),t.is(":focus"))return!1;t.attr("tabindex","-1"),t.focus()}))}});


});